import React, { useState } from 'react'

import pricingCardsTextNodes from '@data/i18n/pricing-cards.json'

import { lang } from '@lib/constants'
import type { SubscriptionBoxSellingPlanData } from '@lib/types'

import AddToCart from '@components/product/ProductView/AddToCart'

export default function PricingCard({
	subscription,
	onAddToCart,
	isBestValue
}: {
	subscription: SubscriptionBoxSellingPlanData
	onAddToCart?: () => void
	isBestValue: boolean
}) {
	const [loading, setLoading] = useState(false)

	const sellingPlanBulletPoints: string[] | undefined =
		// @ts-ignore
		(pricingCardsTextNodes?.products?.[subscription.productId.split('/').pop()] as string[]) ||
		pricingCardsTextNodes?.sellingPlanBulletPoints
	
	const productMatch = (subscription?.productId?.split('/').pop() === pricingCardsTextNodes?.promotionDetails?.product)

	// Set lang for currenty symbol
	const currencySymbols = {
		'en-us': '$',
		'en-gb': '£',
	};

	return (
		<div className="border shrink-0 flex flex-col justify-between pb-6 border-gray-150 bg-white w-[300px] lg:w-[328px] shadow-md md:shadow-bbx-xl">
			{/* Savings text */}
			{isBestValue && (
				<div className="flex justify-center px-10 py-4 bg-bbx-neon-green">
					<span className="text-2xl font-medium lg:text-3xl">
						{pricingCardsTextNodes.topPick}
					</span>
				</div>
			)}

			<div className="flex flex-col px-8 pb-6 mt-6 gap-y-6">
				{/* Title */}
				<h3 className="text-2xl font-medium lg:text-3xl">{subscription.name}</h3>

				{productMatch && (
					// eslint-disable-next-line react/no-danger
					<div className="text-lg bg-bbx-neon-green rounded-full px-5 py-1 w-fit" dangerouslySetInnerHTML={{ __html: pricingCardsTextNodes?.promotionDetails?.calloutText }} />
				)}

				{/* Price */}
				<p className="font-medium text-gray-500">
					<span className="text-2xl font-normal tracking-tight">{subscription.priceHeader}</span>
					<span className="">/ {subscription.frequencyText}</span>
				</p>

				{/* Banner */}
				{/* {subscription.savingsDisplayText && !subscription.savingsDisplayText?.includes('$0.00') && (
					<span className="font-medium text-bbx-blue">
						{subscription.savingsDisplayText} / {subscription.frequencyText}
					</span>
				)} */}
				{/* </div> */}

				{/* Checkmark benefits */}
				{/* TODO: Checkmarks */}
				<ul className="flex-1 mb-8 space-y-3">
					
					{sellingPlanBulletPoints?.map((bulletPoint, index, array) => {
						const isLastBullet = index === array.length - 1;
						
						// Logic to convert months to years and months and convert price to total price
						if (isLastBullet) {
							const bulletPointNumber = Number(bulletPoint);
							// eslint-disable-next-line no-useless-escape
							const priceNumber = parseFloat(subscription.priceHeader.replace(/[\$£]/g, ""));
							const planPrice = Number(priceNumber);
							const totalPrice = (planPrice * bulletPointNumber).toFixed(2);
						
							const years = Math.floor(bulletPointNumber / 12);
							const months = bulletPointNumber % 12;
						
							let timePeriod = `${bulletPointNumber} month${bulletPointNumber > 1 ? 's' : ''}`;
							if (bulletPointNumber >= 12) {
								timePeriod = `${years} year${years > 1 ? 's' : ''}${months > 0 ? `, ${months} month${months > 1 ? 's' : ''}` : ''}`.trim();
							}
							
							return productMatch ? (
								[
									<li key={`renew-${bulletPointNumber}`} className="text-sm list-item-checkmark">
										Renews at {totalPrice}/{timePeriod}
									</li>,
									<li key={`promo-${bulletPointNumber}`} className="text-sm list-item-checkmark">
										{pricingCardsTextNodes?.promotionDetails?.bulletPoint}
									</li>
								]
							) : (
								<li key={`renew-${bulletPointNumber}`} className="text-sm list-item-checkmark" >
									Renews at {currencySymbols[lang as keyof typeof currencySymbols]}{totalPrice}/{timePeriod}
								</li>
							);
						}
						
						return (
							<li className="text-sm list-item-checkmark" key={bulletPoint}>
								{bulletPoint}

							</li>
						)
					})}
				
				</ul>
			</div>

			<div className="mx-6">
				<AddToCart
					product={{
						id: subscription.productId,
						name: subscription.name,
						price: {
							amount: subscription.pricePerMonth.toString(),
							currencyCode: subscription.currencyCode
						},
						vendor: 'birchbox',
						availableForSale: true,
						requiresSellingPlan: true
					}}
					loading={loading}
					setLoading={setLoading}
					sellingPlanId={subscription.sellingPlanId}
					variant={{ id: subscription.variantId, availableForSale: true }}
					ctaText={lang === 'es-es' ? 'Suscríbete' : 'Subscribe'}
					onAddToCart={onAddToCart}
					className="w-full button button-primary"
				/>
			</div>
		</div>
	)
}
